// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"Turtle-module--Inputs--jqJF4","Controls":"Turtle-module--Controls--2cppS"};